// import React, { useEffect, useState } from "react";
// import { Col, Table, Spinner, Badge, Row, Form, Card, Button } from "react-bootstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { authHeader } from "../../../services/auth-header";
// import { BASE_URL } from "../../../services/Api";
// import Swal from "sweetalert2";

// const ViewPumpInternationalSales = () => {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [isLoading, setIsLoading] = useState(true);
//     const [salesData, setSalesData] = useState(null);
//     const [exportchargescurrency, setExportchargescurrency] = useState(0);
//     const [rows, setRows] = useState([]);

//     const fetchSalesData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
//                 headers: authHeader()
//             });

//             const data = response.data;
//             setSalesData(data);
//             setExportchargescurrency(data.exportpreperationchargescurrency || 0);

//             if (data.salesItems && data.salesItems.length > 0) {
//                 setRows(data.salesItems.map(item => ({
//                     description: item.product?.description || '',
//                     productremarks: item.productremarks || "",
//                     quantity: item.quantity,
//                     unitratecurrency: item.unitratecurrency,
//                     totalcurrency: item.totalcurrency,
//                     exchangerate: item.exchangerate,
//                     unitRateInr: item.unitrateinr,
//                     totalInr: item.totalinr,
//                     hsnsacno: item.hsnsacno,
//                     partno: item.partno,
//                     serialnumber: item.serialnumber,
//                     modelnumber: item.modelnumber,
//                     tagnumber: item.tagnumber,
//                     moc: item.moc || "",
//                     itemcode: item.itemcode || "",
//                     uom: item.uom,
//                     currency: item.currency || "$ (USD)"
//                 })));
//             }
//         } catch (error) {
//             console.error("Error fetching sales data", error);
//             Swal.fire({
//                 icon: "error",
//                 title: "Error",
//                 text: "Failed to fetch sales data. Please try again.",
//             });
//             navigate("/salesIndexTable/1");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchSalesData();
//     }, [id]);

//     const formatDate = (dateString) => {
//         if (!dateString) return '-';
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-GB');
//     };

//     const formatNumber = (value) => {
//         if (value === null || value === undefined || value === '') return '0.00';
//         const num = parseFloat(value);
//         return isNaN(num) ? '0.00' : num.toFixed(2);
//     };

//     const formatNumberWithCommas = (value) => {
//         if (value === null || value === undefined || value === '') return '0.00';
//         const num = parseFloat(value);
//         return isNaN(num) ? '0.00' : num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     };

//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'Draft':
//                 return 'secondary';
//             case 'Submitted':
//                 return 'primary';
//             case 'Approved':
//                 return 'success';
//             case 'Rejected':
//                 return 'danger';
//             case 'Completed':
//                 return 'info';
//             case 'Open':
//                 return 'warning';
//             default:
//                 return 'light';
//         }
//     };

//     if (isLoading) {
//         return (
//             <div className="container text-center py-5">
//                 <Spinner animation="border" />
//                 <p>Loading sales details...</p>
//             </div>
//         );
//     }

//     if (!salesData) {
//         return (
//             <div className="container text-center py-5">
//                 <p>No sales data found</p>
//             </div>
//         );
//     }

//     return (
//         <div className="container">
//             <br />
//             <Card.Header className="d-flex justify-content-between align-items-center">
//                 <h5 className="mb-0">International Pump Sales Details</h5>
//                 <Button
//                     variant="primary"
//                     onClick={() => navigate(`/salesInvoiceInternational/print/${id}`)}
//                 >
//                     <i className="bi bi-printer me-2"></i>PRINT
//                 </Button>
//             </Card.Header>
//             <hr />
//             <Form>
//                 {/* Header Information */}
//                 <Row>
//                     <Col md={6}><p><strong>Invoice No:</strong> {salesData.invoiceno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Invoice Date:</strong> {formatDate(salesData.invoicedate)}</p></Col>
//                     <Col md={6}><p><strong>Tally Reference No:</strong> {salesData.tallyreferenceno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Dispatch Through:</strong> {salesData.dispatchthrough || '-'}</p></Col>
//                     <Col md={6}><p><strong>Status:</strong> <Badge bg={getStatusBadge(salesData.status)}>{salesData.status || '-'}</Badge></p></Col>
//                     <Col md={6}><p><strong>Currency:</strong> {salesData.salescurrency || '$ (USD)'}</p></Col>
//                     <Col md={6}><p><strong>Exchange Rate:</strong> {formatNumber(salesData.salesexchangerate)}</p></Col>
//                     <Col md={6}><p><strong>Branch:</strong> {salesData.branch?.branchname || '-'}</p></Col>
//                     <Col md={6}><p><strong>Warehouse:</strong> {salesData.warehouse?.warehousename || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>International Sales Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Kind Attention:</strong> {salesData.kindattn || '-'}</p></Col>
//                     <Col md={6}><p><strong>Country of Destination:</strong> {salesData.countryofdestination || '-'}</p></Col>
//                     <Col md={6}><p><strong>Country of Origin:</strong> {salesData.countryoforigin || '-'}</p></Col>
//                     <Col md={6}><p><strong>Air/Sea:</strong> {salesData.airsea || '-'}</p></Col>
//                     <Col md={6}><p><strong>Port of Loading:</strong> {salesData.portofloading || '-'}</p></Col>
//                     <Col md={6}><p><strong>Port of Discharge:</strong> {salesData.portofdischarge || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Shipping Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={4}><p><strong>No. of Boxes:</strong> {salesData.noofboxes || '-'}</p></Col>
//                     <Col md={4}><p><strong>Net Weight (kg):</strong> {salesData.netweightofboxes || '-'}</p></Col>
//                     <Col md={4}><p><strong>Gross Weight (kg):</strong> {salesData.grossweightofboxes || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Customs & Regulatory Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>LUT Bond No:</strong> {salesData.lutbondno || '-'}</p></Col>
//                     <Col md={6}><p><strong>LUT Bond Date:</strong> {formatDate(salesData.lutbonddate)}</p></Col>
//                     <Col md={6}><p><strong>Type of Shipping Bill:</strong> {salesData.typeofshippingbill || '-'}</p></Col>
//                     <Col md={6}><p><strong>Drawback A/C No:</strong> {salesData.drawbackacno || '-'}</p></Col>
//                     <Col md={4}><p><strong>Chapter Heading:</strong> {salesData.chapterheading || '-'}</p></Col>
//                     <Col md={4}><p><strong>Tariff Item:</strong> {salesData.tariffitem || '-'}</p></Col>
//                     <Col md={4}><p><strong>Drawback Rate:</strong> {salesData.drawbackrate || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Additional Information</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}>
//                         <p><strong>Description:</strong></p>
//                         <div className="border p-2 bg-light">
//                             {salesData.description || '-'}
//                         </div>
//                     </Col>
//                     <Col md={6}>
//                         <p><strong>LUT Details:</strong></p>
//                         <div className="border p-2 bg-light">
//                             {salesData.lut || '-'}
//                         </div>
//                     </Col>
//                     <Col md={6}><p><strong>From Date:</strong> {formatDate(salesData.fromdate)}</p></Col>
//                     <Col md={6}><p><strong>To Date:</strong> {formatDate(salesData.todate)}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Customer Details</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Customer:</strong> {salesData.customer?.companyname || '-'}</p></Col>
//                     <Col md={6}><p><strong>Contact Person:</strong> {salesData.contactperson || '-'}</p></Col>
//                     <Col md={6}><p><strong>Contact No:</strong> {salesData.contactno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Email:</strong> {salesData.email || '-'}</p></Col>
//                     <Col md={6}><p><strong>Customer Address:</strong> {salesData.customeraddress?.customeraddress || '-'}</p></Col>
//                     <Col md={6}><p><strong>Ship To:</strong> {salesData.shipto?.customeraddress || '-'}</p></Col>
//                     <Col md={6}><p><strong>Bill To:</strong> {salesData.billto?.customeraddress || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Terms</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Payment Terms:</strong> {salesData.customer?.paymentterm || '-'}</p></Col>
//                     <Col md={6}><p><strong>Incoterms:</strong> {salesData.customer?.incoterms || '-'}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Additional Information</h5>
//                 <hr />
//                 <Row>
//                     <Col md={6}><p><strong>Destination:</strong> {salesData.destination || '-'}</p></Col>
//                     <Col md={6}><p><strong>Reference:</strong> {salesData.reference || '-'}</p></Col>
//                     <Col md={6}><p><strong>Packing List No:</strong> {salesData.packinglistno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Packing List Date:</strong> {formatDate(salesData.packinglistdate)}</p></Col>
//                     <Col md={6}><p><strong>Buyer Order No:</strong> {salesData.buyerorderno || '-'}</p></Col>
//                     <Col md={6}><p><strong>Buyer Order Date:</strong> {formatDate(salesData.buyerorderdate)}</p></Col>
//                 </Row>

//                 <hr />
//                 <h5>Sales Items</h5>
//                 <div className="table-responsive">
//                     <Table striped bordered hover>
//                         <thead>
//                             <tr>
//                                 <th>Product Description</th>
//                                 <th>Serial No</th>
//                                 <th>Model No</th>
//                                 <th>Tag No</th>
//                                 <th>Part No</th>
//                                 <th>MOC</th>
//                                 <th>Item Code</th>
//                                 <th>HSN Code</th>
//                                 <th>Quantity</th>
//                                 <th>UOM</th>
//                                 <th>Unit Price (Currency)</th>
//                                 <th>Total (Currency)</th>
//                                 <th>Unit Price (INR)</th>
//                                 <th>Total (INR)</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {rows.map((row, index) => (
//                                 <tr key={index}>
//                                     <td>
//                                         {row.description}
//                                         {row.productremarks && (
//                                             <div className="text-muted small mt-2">
//                                                 <strong>Remarks:</strong> {row.productremarks}
//                                             </div>
//                                         )}
//                                     </td>
//                                     <td>{row.serialnumber || '-'}</td>
//                                     <td>{row.modelnumber || '-'}</td>
//                                     <td>{row.tagnumber || '-'}</td>
//                                     <td>{row.partno || '-'}</td>
//                                     <td>{row.moc || '-'}</td>
//                                     <td>{row.itemcode || '-'}</td>
//                                     <td>{row.hsnsacno || '-'}</td>
//                                     <td>{row.quantity || '0'}</td>
//                                     <td>{row.uom || '-'}</td>
//                                     <td>{formatNumber(row.unitratecurrency)}</td>
//                                     <td>{formatNumber(row.totalcurrency)}</td>
//                                     <td>{formatNumber(row.unitRateInr)}</td>
//                                     <td>{formatNumber(row.totalInr)}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </div>

//                 {/* Totals Card */}
//                 <div className="card mt-3" style={{ width: '50%', marginLeft: 'auto' }}>
//                     <div className="card-header bg-light">
//                         <h5 className="mb-0">Sales Summary</h5>
//                     </div>
//                     <div className="card-body">
//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Net Total (INR)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.nettotalinr)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Net Total (Currency)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.nettotalcurrency)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Export Charges (Currency)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(salesData.exportpreperationchargescurrency)}</strong>
//                             </div>
//                         </div>

//                         <div className="row mb-2">
//                             <div className="col-8 text-end">
//                                 <strong>Export Charges (INR)</strong>
//                             </div>
//                             <div className="col-4">
//                                 <strong>{formatNumberWithCommas(
//                                     parseFloat(salesData.exportpreperationchargescurrency || 0) * 
//                                     parseFloat(salesData.salesexchangerate || 1)
//                                 )}</strong>
//                             </div>
//                         </div>

//                         <div className="row mt-3 pt-2 border-top">
//                             <div className="col-8 text-end">
//                                 <h5>Grand Total (INR)</h5>
//                             </div>
//                             <div className="col-4">
//                                 <h5>{formatNumberWithCommas(salesData.grandtotalinr)}</h5>
//                             </div>
//                         </div>

//                         <div className="row mt-2">
//                             <div className="col-8 text-end">
//                                 <h5>Grand Total (Currency)</h5>
//                             </div>
//                             <div className="col-4">
//                                 <h5>{formatNumberWithCommas(salesData.grandtotalcurrency)}</h5>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-end mt-4">
//                     <button
//                         className="btn btn-secondary"
//                         type="button"
//                         onClick={() => navigate("/salesIndexTable/1")}
//                     >
//                         BACK TO LIST
//                     </button>
//                 </div>
//             </Form>
//         </div>
//     );
// };

// export default ViewPumpInternationalSales;





import React, { useEffect, useState } from "react";
import { Col, Table, Spinner, Badge, Row, Container, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";
import Swal from "sweetalert2";
import { FaArrowLeft, FaPrint } from "react-icons/fa";

const ViewPumpInternationalSales = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [salesData, setSalesData] = useState(null);
    const [rows, setRows] = useState([]);

    const fetchSalesData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
                headers: authHeader()
            });

            const data = response.data;
            setSalesData(data);

            if (data.salesItems && data.salesItems.length > 0) {
                setRows(data.salesItems.map(item => ({
                    description: item.product?.description || '',
                    productremarks: item.productremarks || "",
                    quantity: item.quantity,
                    unitratecurrency: item.unitratecurrency,
                    totalcurrency: item.totalcurrency,
                    exchangerate: item.exchangerate,
                    unitRateInr: item.unitrateinr,
                    totalInr: item.totalinr,
                    hsnsacno: item.hsnsacno,
                    partno: item.partno,
                    serialnumber: item.serialnumber,
                    modelnumber: item.modelnumber,
                    tagnumber: item.tagnumber,
                    moc: item.moc || "",
                    itemcode: item.itemcode || "",
                    uom: item.uom,
                    currency: item.currency || "$ (USD)"
                })));
            }
        } catch (error) {
            console.error("Error fetching sales data", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch sales data. Please try again.",
            });
            navigate("/salesIndexTable/1");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSalesData();
    }, [id]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN');
    };

    const formatCurrency = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
        }).format(value || 0);

    const formatNumber = (value) => {
        if (value === null || value === undefined || isNaN(value)) return '0.00';
        return parseFloat(value).toFixed(2);
    };

    const getAddressString = (address) => {
        if (!address) return '-';
        return [
            address.customeraddress,
            address.city?.cityname,
            address.state?.statename,
            address.pincode,
            address.country?.countryname
        ].filter(Boolean).join(', ');
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Draft': return 'secondary';
            case 'Submitted': return 'primary';
            case 'Approved': return 'success';
            case 'Rejected': return 'danger';
            case 'Completed': return 'info';
            case 'Open': return 'warning';
            case 'Active': return 'success';
            default: return 'light';
        }
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!salesData) {
        return <div className="alert alert-danger text-center mt-4">Sales Invoice not found</div>;
    }

    const exportChargesINR = (parseFloat(salesData.exportpreperationchargescurrency || 0) * parseFloat(salesData.salesexchangerate || 1));

    return (
        <Container fluid className="p-3">
            {/* Header Section */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="fw-bold text-primary mb-0">PUMP INTERNATIONAL SALES INVOICE - VIEW</h5>
                        <div>
                            <Button variant="outline-white" size="sm" className="me-2"
                                onClick={() => navigate(`/salesInvoiceInternational/print/${id}`)}
                            >
                                <FaPrint className="me-1" />
                                PRINT
                            </Button>
                            <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                                <FaArrowLeft className="me-1" />
                                Back
                            </Button>
                        </div>
                    </div>

                    <Row className="g-2">
                        <Col md={3}>
                            <div className="border-start border-3 border-primary ps-2">
                                <small className="text-muted">Invoice No</small>
                                <div className="fw-bold">{salesData.invoiceno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-success ps-2">
                                <small className="text-muted">Invoice Date</small>
                                <div className="fw-bold">{formatDate(salesData.invoicedate)}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-warning ps-2">
                                <small className="text-muted">Currency</small>
                                <div className="fw-bold">{salesData.salescurrency || '$ (USD)'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-info ps-2">
                                <small className="text-muted">Status</small>
                                <div>
                                    <Badge bg={getStatusBadge(salesData.status)} className="px-2 py-1">
                                        {salesData.status || '-'}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Branch & Warehouse */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Branch & Warehouse Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={6}>
                            <small className="text-muted">Branch</small>
                            <div className="fw-bold">{salesData.branch?.branchname || '-'}</div>
                        </Col>
                        <Col md={6}>
                            <small className="text-muted">Warehouse</small>
                            <div className="fw-bold">{salesData.warehouse?.warehousename || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Invoice Details */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Invoice Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">Tally Reference No</small>
                            <div className="fw-bold">{salesData.tallyreferenceno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Dispatch Through</small>
                            <div className="fw-bold">{salesData.dispatchthrough || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Exchange Rate (₹/Currency)</small>
                            <div className="fw-bold">{formatNumber(salesData.salesexchangerate)}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Destination</small>
                            <div className="fw-bold">{salesData.destination || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Reference</small>
                            <div className="fw-bold">{salesData.reference || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* International Sales Details */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">International Sales Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">Kind Attention</small>
                            <div className="fw-bold">{salesData.kindattn || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Country of Destination</small>
                            <div className="fw-bold">{salesData.countryofdestination || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Country of Origin</small>
                            <div className="fw-bold">{salesData.countryoforigin || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Air/Sea</small>
                            <div className="fw-bold">{salesData.airsea || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Port of Loading</small>
                            <div className="fw-bold">{salesData.portofloading || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Port of Discharge</small>
                            <div className="fw-bold">{salesData.portofdischarge || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Shipping Details */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Shipping Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">No. of Boxes</small>
                            <div className="fw-bold">{salesData.noofboxes || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Net Weight (kg)</small>
                            <div className="fw-bold">{salesData.netweightofboxes || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Gross Weight (kg)</small>
                            <div className="fw-bold">{salesData.grossweightofboxes || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Customs & Regulatory Details */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Customs & Regulatory Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">LUT Bond No</small>
                            <div className="fw-bold">{salesData.lutbondno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">LUT Bond Date</small>
                            <div className="fw-bold">{formatDate(salesData.lutbonddate)}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Type of Shipping Bill</small>
                            <div className="fw-bold">{salesData.typeofshippingbill || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Drawback A/C No</small>
                            <div className="fw-bold">{salesData.drawbackacno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Chapter Heading</small>
                            <div className="fw-bold">{salesData.chapterheading || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Tariff Item</small>
                            <div className="fw-bold">{salesData.tariffitem || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Drawback Rate</small>
                            <div className="fw-bold">{salesData.drawbackrate || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Additional Information */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Additional Information</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={6}>
                            <small className="text-muted">Description</small>
                            <div className="p-2 rounded mt-1" style={{ backgroundColor: '#f8f9fa' }}>
                                <span className="fw-bold">{salesData.description || '-'}</span>
                            </div>
                        </Col>
                        <Col md={6}>
                            <small className="text-muted">LUT Details</small>
                            <div className="p-2 rounded mt-1" style={{ backgroundColor: '#f8f9fa' }}>
                                <span className="fw-bold">{salesData.lut || '-'}</span>
                            </div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">From Date</small>
                            <div className="fw-bold">{formatDate(salesData.fromdate)}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">To Date</small>
                            <div className="fw-bold">{formatDate(salesData.todate)}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Packing List No</small>
                            <div className="fw-bold">{salesData.packinglistno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Packing List Date</small>
                            <div className="fw-bold">{formatDate(salesData.packinglistdate)}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Buyer Order No</small>
                            <div className="fw-bold">{salesData.buyerorderno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Buyer Order Date</small>
                            <div className="fw-bold">{formatDate(salesData.buyerorderdate)}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Customer Information */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Customer Information</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">Company Name</small>
                            <div className="fw-bold">{salesData.customer?.companyname || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Contact Person</small>
                            <div className="fw-bold">{salesData.contactperson || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">GST No</small>
                            <div className="fw-bold">{salesData.customer?.gstno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Phone</small>
                            <div className="fw-bold">{salesData.contactno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Email</small>
                            <div className="fw-bold">{salesData.email || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Payment Terms</small>
                            <div className="fw-bold">{salesData.customer?.paymentterm || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Incoterms</small>
                            <div className="fw-bold">{salesData.customer?.incoterms || '-'}</div>
                        </Col>
                        <Col md={12}>
                            <small className="text-muted">Address</small>
                            <div className="fw-bold">{getAddressString(salesData.customeraddress)}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Bill To & Ship To */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Billing & Shipping Information</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={6}>
                            <div className="border-start border-3 border-primary ps-3">
                                <small className="text-muted">Bill To</small>
                                <div className="fw-bold">{getAddressString(salesData.billto)}</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="border-start border-3 border-success ps-3">
                                <small className="text-muted">Ship To</small>
                                <div className="fw-bold">{getAddressString(salesData.shipto)}</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Sales Items */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Sales Items</h6>
                </div>
                <div className="p-0">
                    <div className="table-responsive">
                        <Table bordered size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center fw-bold py-2">#</th>
                                    <th className="fw-bold py-2">Description</th>
                                    <th className="fw-bold py-2">Part No</th>
                                    <th className="fw-bold py-2">HSN Code</th>
                                    <th className="fw-bold py-2">Serial No</th>
                                    <th className="fw-bold py-2">Model No</th>
                                    <th className="fw-bold py-2">Tag No</th>
                                    <th className="fw-bold py-2">MOC</th>
                                    <th className="fw-bold py-2">Item Code</th>
                                    <th className="fw-bold py-2 text-center">Qty</th>
                                    <th className="fw-bold py-2 text-center">UOM</th>
                                    <th className="fw-bold py-2 text-end">Unit Rate (Curr)</th>
                                    <th className="fw-bold py-2 text-end">Total (Curr)</th>
                                    <th className="fw-bold py-2 text-end">Unit Rate (₹)</th>
                                    <th className="fw-bold py-2 text-end">Total (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td>
                                            <div className="fw-semibold">{row.description || '-'}</div>
                                            {row.productremarks && row.productremarks !== '-' && (
                                                <div className="text-muted small mt-1">
                                                    <small><strong>Remarks:</strong> {row.productremarks}</small>
                                                </div>
                                            )}
                                        </td>
                                        <td>{row.partno || '-'}</td>
                                        <td>{row.hsnsacno || '-'}</td>
                                        <td>{row.serialnumber || '-'}</td>
                                        <td>{row.modelnumber || '-'}</td>
                                        <td>{row.tagnumber || '-'}</td>
                                        <td>{row.moc || '-'}</td>
                                        <td>{row.itemcode || '-'}</td>
                                        <td className="text-center">{row.quantity || '0'}</td>
                                        <td className="text-center">{row.uom || '-'}</td>
                                        <td className="text-end">{formatNumber(row.unitratecurrency)}</td>
                                        <td className="text-end">{formatNumber(row.totalcurrency)}</td>
                                        <td className="text-end">{formatCurrency(row.unitRateInr)}</td>
                                        <td className="text-end fw-semibold">{formatCurrency(row.totalInr)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {/* Calculation Summary */}
            <Row>
                <Col lg={6} className="ms-auto">
                    <div className="shadow-sm border rounded bg-white">
                        <div className="bg-light py-2 px-3 border-bottom">
                            <h6 className="mb-0 fw-bold text-center">Amount Calculation</h6>
                        </div>
                        <div className="p-3">
                            <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span className="fw-semibold">Net Total (INR):</span>
                                <span className="fw-bold">{formatCurrency(salesData.nettotalinr)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span className="fw-semibold">Net Total (Currency):</span>
                                <span className="fw-bold">{formatNumber(salesData.nettotalcurrency)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span className="fw-semibold">Export Charges (Currency):</span>
                                <span className="fw-bold">{formatNumber(salesData.exportpreperationchargescurrency)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span className="fw-semibold">Export Charges (INR):</span>
                                <span className="fw-bold">{formatCurrency(exportChargesINR)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2 border-top">
                                <span className="fw-bold">Grand Total (INR)</span>
                                <span className="fw-bold text-primary">{formatCurrency(salesData.grandtotalinr)}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center py-2">
                                <span className="fw-bold">Grand Total (Currency)</span>
                                <span className="fw-bold text-success">{formatNumber(salesData.grandtotalcurrency)}</span>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Footer Actions */}
            <div className="text-center mt-3 pt-2 border-top">
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => navigate("/salesIndexTable/1")}
                >
                    <FaArrowLeft className="me-1" />
                    Back to List
                </Button>
            </div>
        </Container>
    );
};

export default ViewPumpInternationalSales;